import React, { ReactElement } from 'react';

import { useForm } from 'react-hook-form';
import { Button, LbInput } from '@infoods/lifebase-ui';
import { observer } from 'mobx-react';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import {
  HiddenInput,
  LbAutocomplete,
} from '../../../../shared/components/form-components';
import { CoachListFormValues } from '../../../interfaces/coach-list/CoachListFilters';
import { useAutoSubmitForm } from '../../../../shared/hooks/useAutoSubmitForm';
import { states } from '../../../../shared/constants/states';
import {
  COACH_LIST_COLUMN,
  CoachListColumn,
  CoachListMode,
} from '../NgzCoachList.settings';
import { useCoachListStore } from '../hooks/useCoachListStore';

type FilterRowProps = {
  visibleColumns: CoachListColumn[];
  listMode: CoachListMode;
};

const FilterRow = observer(({ visibleColumns, listMode }: FilterRowProps) => {
  const { filterMethods } = useCoachListStore(listMode);
  const { defaultFilterData, filterData, applyFilters } = filterMethods;

  const { control, register, handleSubmit, reset, watch } = useForm<CoachListFormValues>({
    defaultValues: filterData,
  });

  useAutoSubmitForm(handleSubmit(applyFilters), watch, [
    'name',
    'entityId',
    'entityCity',
  ]);

  const handleReset = () => {
    reset({ ...defaultFilterData });
  };

  const generalInputProps = { control, variant: 'outlined', size: 'small' } as const;

  const renderColumnsInfo: Record<CoachListColumn, ReactElement> = {
    [COACH_LIST_COLUMN.NAME]: (
      <LbInput {...generalInputProps} name="name" placeholder="Full name" />
    ),
    [COACH_LIST_COLUMN.ENTITY]: (
      <LbInput
        {...generalInputProps}
        name="entityId"
        placeholder="Entity id"
        type="number"
      />
    ),
    [COACH_LIST_COLUMN.STATE]: (
      <LbAutocomplete
        {...generalInputProps}
        name="state"
        label="Entity state"
        options={states}
      />
    ),
    [COACH_LIST_COLUMN.CITY]: (
      <LbInput {...generalInputProps} name="entityCity" placeholder="Entity city" />
    ),
    [COACH_LIST_COLUMN.SETUP_COMMISSION]: (
      <LbInput
        {...generalInputProps}
        name="commissionSetUp"
        placeholder="Setup comsn"
        type="number"
      />
    ),
    [COACH_LIST_COLUMN.RENEW_COMMISSION]: (
      <LbInput
        {...generalInputProps}
        name="commissionRenew"
        placeholder="Renew comsn"
        type="number"
      />
    ),
    [COACH_LIST_COLUMN.COACH_DESIGNATION]: <div />,
    [COACH_LIST_COLUMN.STATUS]: <div />,
    [COACH_LIST_COLUMN.EXTRA_INFO]: (
      <GridTableCell justify="stretch">
        <Button
          variant="outlined"
          size="small"
          type="reset"
          fullWidth
          onClick={handleReset}
        >
          Clear All
        </Button>
      </GridTableCell>
    ),
  };

  return (
    <GridTableRow
      variant="filter"
      component="form"
      onSubmit={(event) => event.preventDefault()}
    >
      <HiddenInput register={register} name="withSolutionType" />
      {visibleColumns.map((col) => (
        <React.Fragment key={col}>{renderColumnsInfo[col]}</React.Fragment>
      ))}
    </GridTableRow>
  );
});

export { FilterRow };
